export const SERVER_URL = "http://localhost:5000"
//export const SERVER_URL = process.env.NODE_ENV === "development" ?"http://localhost:5000":"https://vclass.onrender.com"
//https://vclass-production.up.railway.app
